import { render, staticRenderFns } from "./PurchaseStat.vue?vue&type=template&id=d8b0b3b0&scoped=true&"
import script from "./PurchaseStat.vue?vue&type=script&lang=js&"
export * from "./PurchaseStat.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseStat.vue?vue&type=style&index=0&id=d8b0b3b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b0b3b0",
  null
  
)

export default component.exports